window.removeURLParameter = function (parameter) {
  var url = window.location.href;
  var urlparts = url.split("?");
  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + "=";
    var pars = urlparts[1].split(/[&;]/g);

    for (var i = pars.length; i-- > 0; ) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    url = urlparts[0] + "?" + pars.join("&");
    return url;
  } else {
    return url;
  }
};
let sticky = document.querySelector("sticky-atc");

const discontinuedMap = () => {
  const el = document.querySelector("[data-variants-discontinued-json]");
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (err) {
    return null;
  }
};

const applyDiscontinued = (isDiscontinued) => {
  const docData = document.querySelectorAll(
    ".affirm-as-low-as, .pdp-atc-divider, .metafield-data-additional, .product--button-wrapper, .ProductMeta__ShareButtons, .product-info-tabination, .ProductMeta__PriceList",
  );
  const discontinuedEle = document.querySelector(".ProductMeta__discontinued");
  const stickyBar = document.querySelector("sticky-atc");
  docData.forEach((ele) => ele.classList.toggle("d-none", isDiscontinued));
  if (
    discontinuedEle &&
    !discontinuedEle.classList.contains("is_product_discontinued")
  ) {
    discontinuedEle.classList.toggle("d-none", !isDiscontinued);
  }
  if (stickyBar) {
    stickyBar.style.visibility = isDiscontinued ? "hidden" : "unset";
  }
};

{
  const map = discontinuedMap();
  const selected = document.querySelector('[name="id"]');
  const entry = map && selected && map[`${selected.value}`];
  if (sticky && entry && entry.discontinued) {
    sticky.style.visibility = "hidden";
  }
}

// prestige emits this for swatches, dropdowns and popovers alike
document.addEventListener("variant:changed", (e) => {
  const variant = e.detail && e.detail.variant;
  const map = discontinuedMap();
  if (!variant || !map) return;
  const entry = map[`${variant.id}`];
  if (!entry) return;
  applyDiscontinued(!!entry.discontinued);
});

window.addEventListener("DOMContentLoaded", () => {
  if (
    window.location.search.includes("contact_posted=true") &&
    window.location.hash === "#share-cart-form"
  ) {
    const shareCartModal = document.getElementById("share-cart-modal");
    if (shareCartModal && shareCartModal.open) {
      shareCartModal.open();
    }

    const cleanUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname;
    window.history.pushState({}, "", cleanUrl);
  }

  if (document.querySelector(".swiper--thumbnails")) {
    window.swiperPdpThumbnail = new Swiper(".swiper--thumbnails", {
      direction: "vertical",
      slidesPerView: 4,
      spaceBetween: 0,
      autoHeight: true,
      loop: false,
      grabCursor: true,
      speed: 800,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper--thumbnails-nav.swiper-button-next",
        prevEl: ".swiper--thumbnails-nav.swiper-button-prev",
      },
    });
  }

  const searchTrigger = document.querySelector(".search__uniq");
  const customSearch = document.querySelector(".customSearch");
  const searchClose = document.querySelector(".closeCustomSearch");
  const searchInput = customSearch?.querySelector(".Search__Input");
  const searchResults = customSearch?.querySelector(".Search__Results");
  const pageOverlay = document.querySelector(".PageOverlay");
  const mobileSearchMedia = window.matchMedia("(max-width: 1139px)");

  const headerSearchIcon = customSearch?.querySelector(".header__search-icon");
  const searchForm = searchInput?.closest("form");

  // whitespace alone isnt a query, keep the panel gates off for it
  const hasRealQuery = () => !!searchInput && searchInput.value.trim() !== "";

  const searchMode = (window.theme && window.theme.searchMode) || "product";
  const searchBase = (window.routes && window.routes.searchUrl) || "/search";
  const twoColumn = (a, b) =>
    '<div class="PageLayout PageLayout--breakLap">' +
    '<div class="PageLayout__Section">' +
    a +
    "</div>" +
    '<div class="PageLayout__Section PageLayout__Section--secondary">' +
    b +
    "</div>" +
    "</div>";

  let searchSeq = 0;
  let searchTimer = null;
  let searchAbort = null;
  let searchLoading = false;

  const themeLoading = (on) => {
    if (on === searchLoading) return;
    searchLoading = on;
    document.dispatchEvent(
      new CustomEvent(on ? "theme:loading:start" : "theme:loading:end"),
    );
  };

  // shopify tokenizes on whitespace, so the wildcard has to ride the last token
  const buildTerm = (raw) => {
    const tokens = String(raw).split(/\s+/).filter(Boolean);
    if (!tokens.length) return "";
    tokens[tokens.length - 1] += "*";
    return tokens.join(" ");
  };

  const cancelSearch = () => {
    clearTimeout(searchTimer);
    searchTimer = null;
    searchSeq++;
    if (searchAbort) searchAbort.abort();
    searchAbort = null;
  };

  const resetSearchResults = () => {
    cancelSearch();
    themeLoading(false);
    document.body.classList.remove("is-search-loading", "is-search-panel");
    if (!searchResults) return;
    searchResults.innerHTML = searchMode === "product" ? "" : twoColumn("", "");
    searchResults.setAttribute("aria-hidden", "true");
  };

  const runSearch = (raw) => {
    const term = buildTerm(raw);
    if (!term) {
      resetSearchResults();
      return;
    }

    cancelSearch();
    const seq = searchSeq;
    const controller =
      typeof AbortController === "function" ? new AbortController() : null;
    searchAbort = controller;

    // scrolled results drag the overlay with them
    if (searchResults) searchResults.scrollTop = 0;
    document.body.classList.add("is-search-loading", "is-search-panel");
    themeLoading(true);

    const q = encodeURIComponent(term);
    const urls = [searchBase + "?view=ajax&q=" + q + "&type=product"];
    if (searchMode !== "product") {
      urls.push(
        searchBase +
          "?view=ajax&q=" +
          q +
          "&type=" +
          searchMode.replace("product,", ""),
      );
    }

    const settle = () => {
      searchAbort = null;
      themeLoading(false);
      document.body.classList.remove("is-search-loading");
    };

    Promise.all(
      urls.map((url) =>
        fetch(url, {
          method: "GET",
          credentials: "same-origin",
          signal: controller ? controller.signal : undefined,
        }).then((resp) => resp.text()),
      ),
    )
      .then((contents) => {
        // a newer query already owns the panel
        if (seq !== searchSeq) return;
        settle();
        if (!searchResults) return;
        searchResults.innerHTML =
          searchMode === "product"
            ? contents[0]
            : twoColumn(contents[0], contents[1]);
        searchResults.setAttribute("aria-hidden", "false");
      })
      .catch(() => {
        if (seq !== searchSeq) return;
        settle();
      });
  };

  const onSearchInput = () => {
    if (!searchInput) return;
    const raw = searchInput.value;
    const live = raw.trim() !== "";

    headerSearchIcon?.classList.toggle("has-value", raw !== "");
    live ? lockPageScroll() : unlockPageScroll();
    setSearchingState(live);

    clearTimeout(searchTimer);
    if (!live) {
      resetSearchResults();
      return;
    }
    searchTimer = setTimeout(() => runSearch(raw), 250);
  };

  // capture beats the target-phase handler prestige binds on the field
  (searchForm || customSearch)?.addEventListener(
    "input",
    (event) => {
      if (event.target !== searchInput) return;
      event.stopPropagation();
      onSearchInput();
    },
    true,
  );

  headerSearchIcon?.addEventListener("click", () => {
    if (!searchInput) return;
    searchInput.value = "";
    onSearchInput();
  });

  if (searchResults) {
    new MutationObserver(() => {
      if (
        searchResults.getAttribute("aria-hidden") === "false" &&
        hasRealQuery()
      )
        document.body.classList.add("is-search-panel");
    }).observe(searchResults, {
      attributes: true,
      attributeFilter: ["aria-hidden"],
    });
  }

  let searchScrollLocked = false;
  const blockBgScroll = (e) => {
    if (!searchResults || !searchResults.contains(e.target)) e.preventDefault();
  };
  const lockPageScroll = () => {
    if (searchScrollLocked) return;
    searchScrollLocked = true;
    window.addEventListener("wheel", blockBgScroll, { passive: false });
    window.addEventListener("touchmove", blockBgScroll, { passive: false });
  };
  const unlockPageScroll = () => {
    if (!searchScrollLocked) return;
    searchScrollLocked = false;
    window.removeEventListener("wheel", blockBgScroll, { passive: false });
    window.removeEventListener("touchmove", blockBgScroll, { passive: false });
  };

  const closeCustomSearch = () => {
    if (!customSearch) return;
    customSearch.classList.remove("is-show");
    customSearch.setAttribute("aria-hidden", "true");
    if (searchInput) searchInput.value = "";
    headerSearchIcon?.classList.remove("has-value");
    // markup stays put so the close fade has something to fade
    cancelSearch();
    themeLoading(false);
    if (searchResults) searchResults.setAttribute("aria-hidden", "true");
    if (document.body.classList.contains("is-searching"))
      holdOverlayThroughFade();
    document.body.classList.remove(
      "is-searching",
      "is-search-panel",
      "is-search-loading",
    );
    unlockPageScroll();
  };

  searchTrigger?.addEventListener("click", (event) => {
    event.preventDefault();
    if (!customSearch) return;
    customSearch.classList.add("is-show");
    customSearch.setAttribute("aria-hidden", "false");
    searchInput?.focus();
  });

  searchClose?.addEventListener("click", closeCustomSearch);

  let searchCloseTimer = null;
  const holdOverlayThroughFade = () => {
    document.body.classList.add("is-search-closing");
    clearTimeout(searchCloseTimer);
    searchCloseTimer = setTimeout(
      () => document.body.classList.remove("is-search-closing"),
      350,
    );
  };

  const setSearchingState = (on) => {
    if (on) {
      clearTimeout(searchCloseTimer);
      document.body.classList.remove("is-search-closing");
    } else {
      if (document.body.classList.contains("is-searching"))
        holdOverlayThroughFade();
      document.body.classList.remove("is-search-panel");
    }
    document.body.classList.toggle("is-searching", on);
  };

  pageOverlay?.addEventListener("click", () => {
    if (
      searchResults?.getAttribute("aria-hidden") === "false" ||
      customSearch?.classList.contains("is-show")
    ) {
      closeCustomSearch();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && customSearch?.classList.contains("is-show"))
      closeCustomSearch();
  });

  const syncSearchVisibility = () => {
    if (!customSearch) return;
    if (
      mobileSearchMedia.matches &&
      !customSearch.classList.contains("is-show")
    ) {
      customSearch.setAttribute("aria-hidden", "true");
    } else if (!mobileSearchMedia.matches) {
      customSearch.classList.remove("is-show");
      customSearch.setAttribute("aria-hidden", "false");
    }
  };

  syncSearchVisibility();
  if (mobileSearchMedia.addEventListener) {
    mobileSearchMedia.addEventListener("change", syncSearchVisibility);
  } else {
    mobileSearchMedia.addListener(syncSearchVisibility);
  }

  const sendUsYourCartModel = document.querySelector("#share-cart-modal form");
  sendUsYourCartModel?.addEventListener("submit", (e) => {
    var data = window.data.cart || {};
    var cart = {
      total_price: data?.total_price / 100,
      $value: data?.total_price / 100,
      total_discount: data?.total_discount,
      original_total_price: data?.original_total_price / 100,
      items: data?.items,
    };
    if (typeof item !== "undefined") {
      cart = Object.assign(cart, item);
    }
    if (typeof _learnq !== "undefined") {
      _learnq.push(["track", "Added to Cart", cart]);
    }
  });
});

let domEvents = ["DOMContentLoaded", "resize"];
domEvents.forEach((e) => {
  window.addEventListener(e, () => {
    let buyBtnWrapper = document.querySelector(".product--button-wrapper ");
    if (buyBtnWrapper) {
      buyBtnWrapper.style.pointerEvents = null;
    }
  });
});

document.addEventListener(
  "click",
  function (e) {
    var btn =
      e.target.closest &&
      e.target.closest('[data-action="toggle-collapsible"]');
    if (!btn) return;
    var collapsible = btn.closest(".Collapsible");
    var inner = collapsible && collapsible.querySelector(".Collapsible__Inner");
    if (!inner) return;

    if (collapsible.dataset.toggling === "1") {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    collapsible.dataset.toggling = "1";
    var clear = function () {
      collapsible.dataset.toggling = "";
      inner.removeEventListener("transitionend", onEnd);
      clearTimeout(fallback);
    };
    var onEnd = function (ev) {
      if (ev.target === inner && ev.propertyName === "height") clear();
    };
    inner.addEventListener("transitionend", onEnd);
    var fallback = setTimeout(clear, 500);
  },
  true,
);
